module.exports = __webpack_public_path__ + "img/djPlace.19689b56.png";